"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValue = void 0;
/**
 * Key value to expose the raw key in byte-array data and its encryption type
 */
class KeyValue {
    /**
     * Initialize the KeyValue with specific raw-key and encryption type
     * @param key
     * @param encryptionType
     */
    constructor(key, encryptionType) {
        if (!key || !key.length) {
            throw new Error("Key is required");
        }
        if (!encryptionType) {
            throw new Error("Encryption type is required");
        }
        this._key = key;
        this._encryptionType = encryptionType;
    }
    /**
     * Get the current raw-key value
     */
    get key() {
        return this._key;
    }
    /**
     * Get the encryption type of key
     */
    get encryptionType() {
        return this._encryptionType;
    }
}
exports.KeyValue = KeyValue;
